import { render } from "./PaginatedTable.vue?vue&type=template&id=9b235620"
import script from "./PaginatedTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginatedTable.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/exhishare/PaginatedTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b235620"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b235620', __exports__)) {
    api.reload('9b235620', __exports__)
  }
  
  module.hot.accept("./PaginatedTable.vue?vue&type=template&id=9b235620", () => {
    api.rerender('9b235620', render)
  })

}


export default __exports__